@if (org && pageTemplate) {
  <div
    class="container {{ responsive.responsiveClassName }} {{ page }}"
    [class.mat-elevation-z2]="responsive.isDesktop"
  >
    <app-language-switch class="p-1"></app-language-switch>
    @if (page !== "document") {
      <div class="left">
        <div class="page">
          <ng-container *ngTemplateOutlet="pageTemplate"></ng-container>
        </div>
        <div class="footer">
          <div class="link">
            Powered by <a href="https://www.utisha.com">Utisha</a>
          </div>
        </div>
      </div>
      <div class="right">
        @if (org.loginBanner) {
          @if (org.loginBanner) {
            <app-s3-img
              width="auto"
              [uuid]="org.loginBanner"
              class="logo"
              borderRadius="0 15px 15px 0"
            ></app-s3-img>
          }
        } @else {
          <img src="/assets/img/utisha_default_login_image.png" class="logo" />
        }
      </div>
    } @else {
      <div class="conditions">
        <ng-container
          [ngTemplateOutlet]="titleTemplate"
          [ngTemplateOutletContext]="{
            customTitle: titleFor(selectedConditionsDocument),
          }"
        ></ng-container>
        <ng-scrollbar track="vertical" trackClass="light-scrollbar">
          <div
            class="conditions__content"
            [innerHTML]="contentsFor(selectedConditionsDocument)"
          ></div>
        </ng-scrollbar>
      </div>
    }
  </div>
}

<ng-template templateName="authMethod">
  <ng-container
    [ngTemplateOutlet]="titleTemplate"
    [ngTemplateOutletContext]="{ title: 'login.title' }"
  ></ng-container>
  <ng-container [ngTemplateOutlet]="introTemplate"></ng-container>
  <app-login-choice
    [title]="'login.choice.login-title'"
    (selected)="handleSelectedLoginMethod($event)"
  ></app-login-choice>
  @if (error) {
    <div class="error">{{ error | translate }}</div>
  }
  <div class="conditions-links">
    @if (conditionsStatement) {
      <span
        [innerHTML]="
          'login.accept conditions.1' | translate: { customer: org.name }
        "
      ></span
      >&nbsp;
      <a
        href="#"
        (click)="showDoc(conditionsStatement)"
        [innerHTML]="'document.type.' + conditionsStatement.type | translate"
      ></a>
      <span
        [innerHTML]="
          'login.accept conditions.2' | translate: { customer: org.name }
        "
      ></span
      >&nbsp;
    }
    @if (privacyStatement) {
      <span
        [innerHTML]="
          'login.privacy statement.1' | translate: { customer: org.name }
        "
      ></span
      >&nbsp;
      <a
        href="#"
        (click)="showDoc(privacyStatement)"
        [innerHTML]="'document.type.' + privacyStatement.type | translate"
      ></a>
      <span
        [innerHTML]="
          'login.privacy statement.2' | translate: { customer: org.name }
        "
      ></span
      >&nbsp;
    }
  </div>
</ng-template>

<ng-template templateName="enterEmail">
  <ng-container [ngTemplateOutlet]="titleTemplate"></ng-container>
  <ng-container
    [ngTemplateOutlet]="introTemplate"
    [ngTemplateOutletContext]="{ translateArgs: { email } }"
  ></ng-container>
  <ut-input
    id="email"
    [placeholder]="'login.email.label' | translate"
    [(ngModel)]="email"
    (keyup.enter)="submitEmail()"
  ></ut-input>
  <ut-button
    id="email-submit"
    class="wide"
    variant="primary"
    [loading]="submitting"
    (clicked)="submitEmail()"
  >
    {{ 'login.continue' | translate }}
  </ut-button>
  <ng-container [ngTemplateOutlet]="errorTemplate"></ng-container>
</ng-template>

<ng-template templateName="enterPassword">
  <ng-container [ngTemplateOutlet]="titleTemplate"></ng-container>
  <ng-container [ngTemplateOutlet]="introTemplate"></ng-container>
  <ut-input
    id="password"
    type="password"
    [placeholder]="'login.new-user-password.label' | translate"
    [(ngModel)]="password"
    (keyup.enter)="submitPassword()"
  ></ut-input>
  @if (page === "existing-user-password") {
    <div class="hint">
      <a href="#" (click)="gotoForgotPassword()">Forgot password?</a>
    </div>
  }

  <ut-button
    id="password-submit"
    class="wide"
    variant="primary"
    (clicked)="submitPassword()"
    [disabled]="!isPasswordValid()"
    [loading]="submitting"
  >
    {{ 'login.' + page + '.button' | translate }}
  </ut-button>
  <ng-container [ngTemplateOutlet]="errorTemplate"></ng-container>
</ng-template>

<ng-template templateName="loggedIn">
  <ng-container [ngTemplateOutlet]="titleTemplate"></ng-container>
  <div
    class="intro"
    [innerHTML]="'login.logged-in.intro' | translate: { email: user.email }"
  ></div>
  <ut-button class="wide" variant="primary" (clicked)="nav.home()">
    {{ 'login.' + page + '.button' | translate }}
  </ut-button>
  <ut-button
    variant="secondary"
    (clicked)="logout()"
  >
    {{ 'logout' | translate }}
  </ut-button>
</ng-template>

<ng-template templateName="signup">
  <ng-container [ngTemplateOutlet]="titleTemplate"></ng-container>
  <ng-container
    [ngTemplateOutlet]="introTemplate"
    [ngTemplateOutletContext]="{ translateArgs: { email } }"
  ></ng-container>
  <ut-input
    [placeholder]="'login.signup.name' | translate"
    [(ngModel)]="name"
    (keyup.enter)="submitName()"
  ></ut-input>
  <ut-button class="wide" variant="primary" (clicked)="submitName()">
    {{ 'login.' + page + '.button' | translate }}
  </ut-button>
  <ng-container [ngTemplateOutlet]="errorTemplate"></ng-container>
</ng-template>

<ng-template templateName="signupSuccess">
  <ng-container [ngTemplateOutlet]="titleTemplate"></ng-container>
  <ng-container [ngTemplateOutlet]="introTemplate"></ng-container>
  <ut-button class="wide" variant="primary" (clicked)="finishSignup()">
    {{ 'login.signup-success.button' | translate }}
  </ut-button>
</ng-template>

<ng-template templateName="confirmed">
  <ng-container [ngTemplateOutlet]="titleTemplate"></ng-container>
  <ng-container [ngTemplateOutlet]="introTemplate"></ng-container>
  <ut-button class="wide" variant="primary" (clicked)="finishSignup()">
    {{ 'login.confirmed.button' | translate }}
  </ut-button>
</ng-template>

<ng-template templateName="unconfirmed">
  <ng-container [ngTemplateOutlet]="titleTemplate"></ng-container>
  <ng-container [ngTemplateOutlet]="introTemplate"></ng-container>
  <ut-button
    [disabled]="!email"
    class="wide"
    variant="primary"
    [loading]="submitting"
    (clicked)="resendConfirmationMail()"
  >
    {{ 'login.unconfirmed.button' | translate }}
  </ut-button>
  <ng-container [ngTemplateOutlet]="errorTemplate"></ng-container>
</ng-template>

<ng-template templateName="forgotPassword">
  <ng-container [ngTemplateOutlet]="titleTemplate"></ng-container>
  <ng-container [ngTemplateOutlet]="introTemplate"></ng-container>
  <ut-input
    [placeholder]="'login.email.label' | translate"
    [(ngModel)]="email"
    (keyup.enter)="submitForgotPassword()"
  ></ut-input>
  <ut-button
    class="wide"
    variant="primary"
    [loading]="submitting"
    (clicked)="submitForgotPassword()"
  >
    {{ 'login.continue' | translate }}
  </ut-button>
  <ng-container [ngTemplateOutlet]="errorTemplate"></ng-container>
</ng-template>

<ng-template templateName="resetPassword">
  <ng-container [ngTemplateOutlet]="titleTemplate"></ng-container>
  <ng-container [ngTemplateOutlet]="introTemplate"></ng-container>

  <app-change-password
    (success)="handlePasswordChanged()"
    (cancel)="cancelPasswordChange()"
  ></app-change-password>
</ng-template>

<ng-template templateName="resetPasswordSuccess">
  <ng-container [ngTemplateOutlet]="titleTemplate"></ng-container>
  <ng-container [ngTemplateOutlet]="introTemplate"></ng-container>
  <ut-button
    class="wide"
    variant="primary"
    (clicked)="gotoPage('existing-user-password')"
  >
    {{ 'login.forgot-password-submitted.button' | translate }}
  </ut-button>
</ng-template>

<ng-template templateName="forgotPasswordSubmitted">
  <ng-container [ngTemplateOutlet]="titleTemplate"></ng-container>
  <ng-container [ngTemplateOutlet]="introTemplate"></ng-container>
  <ut-button
    class="wide"
    variant="primary"
    (clicked)="gotoPage('existing-user-password')"
  >
    {{ 'login.forgot-password-submitted.button' | translate }}
  </ut-button>
</ng-template>

<ng-template templateName="authError">
  <ng-container [ngTemplateOutlet]="titleTemplate"></ng-container>
  <ng-container [ngTemplateOutlet]="introTemplate"></ng-container>
  <ut-button
    class="wide"
    variant="primary"
    (clicked)="gotoPage('auth-method')"
  >
    {{ 'login.auth-error.button' | translate }}
  </ut-button>
</ng-template>

<ng-template #introTemplate let-translateArgs="translateArgs">
  <div
    class="intro"
    [innerHTML]="'login.' + page + '.intro' | translate: translateArgs"
  ></div>
</ng-template>

<ng-template #errorTemplate>
  @if (error) {
    <div class="error-wrapper">
      @if (error) {
        <div class="error">{{ error | translate }}</div>
      }
    </div>
  }
</ng-template>

<ng-template #titleTemplate let-customTitle="customTitle">
  <div class="title">
    @if (back) {
      <ut-icon name="chevron-left" class="back" (click)="back()"></ut-icon>
    }
    @if (customTitle) {
      <div class="text">{{ customTitle | translate }}</div>
    }
    @if (!customTitle) {
      <div class="text">{{ 'login.' + page + '.title' | translate }}</div>
    }
  </div>
</ng-template>
